import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { map } from 'rxjs/operators';
import { PlatformDomain } from '@models/platform-domain';

@Injectable({
  providedIn: 'root'
})
export class PlatformDomainService {
  private readonly baseUrl;

  constructor(private http: HttpClient) {
    this.baseUrl = environment.serverBaseUrl;
  }

  getPlatformDomainInfo(): Observable<PlatformDomain> {
    return this.http.get<Response>(this.baseUrl + 'domain').pipe(map(data => PlatformDomain.deserialize(data)));
  }
}
